import { render, staticRenderFns } from "./AccountTransactions.vue?vue&type=template&id=4d10c1e5&scoped=true"
import script from "./AccountTransactions.vue?vue&type=script&lang=js"
export * from "./AccountTransactions.vue?vue&type=script&lang=js"
import style0 from "./AccountTransactions.vue?vue&type=style&index=0&id=4d10c1e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10c1e5",
  null
  
)

export default component.exports